import React from 'react';
import type { FC } from 'react';
import Link from '@wix/thunderbolt-elements/src/components/Link/viewer/Link';
import classNames from 'clsx';

import type { LoginSocialBarMenuItemProps } from '../../../../LoginSocialBar.types';
import { TEST_ID_LINK } from '../../../../constants';
import styles from './LoginSocialBarCustomMenu.module.scss';

type MenuItemsProps = {
  items: Array<LoginSocialBarMenuItemProps>;
  onLinkClick: (item: LoginSocialBarMenuItemProps) => void;
  currentPrimaryPageHref: string;
  useNestedMenuItems: boolean;
};

export const MenuItems: FC<MenuItemsProps> = ({
  items,
  ...passThroughProps
}) => {
  const { onLinkClick, currentPrimaryPageHref, useNestedMenuItems } =
    passThroughProps;

  return (
    <ul className={styles.menuItemsGroup}>
      {items.map((item, index) => {
        return (
          <React.Fragment key={index}>
            <li>
              <Link
                role="menuitem"
                onClick={() => onLinkClick(item)}
                {...item.link}
                dataTestId={TEST_ID_LINK}
                className={classNames(styles.link, {
                  [styles.selected]:
                    !!item.link.href &&
                    item.link.href === currentPrimaryPageHref,
                })}
              >
                <span className={styles.label}>{item.label}</span>
                {typeof item.displayCount === 'number' && (
                  <span className={styles.displayCount}>
                    ({item.displayCount})
                  </span>
                )}
              </Link>
            </li>

            {useNestedMenuItems && !!item.items?.length && (
              <MenuItems items={item.items} {...passThroughProps} />
            )}
          </React.Fragment>
        );
      })}
    </ul>
  );
};
